module.exports = __webpack_public_path__ + "static/media/manu-11.e2666a69.png";